import * as types from "./mutations-types";

/**
 * Export all mutations
 */
export default {
  /**
   * @param state
   * @param {boolean} is_auth_error_handled
   */
  [types.SET_IS_AUTH_ERROR_HANDLED](state, payload) {
    state.is_auth_error_handled = payload;
  }
}